module.exports = __webpack_public_path__ + "static/media/GirlsHandshake.be5042d5.jpeg";